<section class="ft-master-section ft-roadmap-master">
    <section class="ft-section">
        <div class="ft-container">
            <div class="ft-heading ft-text-plus-2" style="text-align:center;">
                Stay tuned as we work on new features for your cooperative.
            </div>
        </div>
    </section>
    <section class="ft-section">
        <div class="ft-container">
            <div class="ft-row">
                <div class="ft-col-50 ft-col-right">
                    <div class="ft-section-image ft-screenshot mod-3d-rotate-left ft-screen-nurturingemail is-scrollable">
                        <div class="ft-browserchrome"></div>
                        <div class="ft-browserviewport"></div>
                        <div class="ft-icn-scrollable"><span>Scroll image</span></div>
                        <div class="ft-section-image-caption">
                            <p>Concept preview. Final product may differ.</p>
                        </div>
                    </div>
                </div>
                <div class="ft-col-50">
                    <div class="ft-section-info">
                        <div class="ft-heading ft-text-plus-3">
                            Nurturing
                        </div>
                        <p class="ft-text-plus-2">
                            Turn travelers that aren&rsquo;t interested into warm leads.
                        </p>
                        <p>
                            Some travelers just won&rsquo;t want to travel to your destination&mdash;they may have been there recently, traveled in the past with no desire for a return visit, or have no interest to begin with&mdash;all reasons that are beyond your control. But that doesn&rsquo;t mean these travelers lose any value for your marketing efforts.
                        </p>
                        <p>
                            With Nurturing, you take an active part in helping these travelers get to where they want to go. Introduce them to cooperative teams at other destinations, learn where they want to go, and send them off on a high note (your hospitable gesture will certainly be appreciated).
                        </p>
                        <p>
                            Other cooperatives send travelers your way&mdash;leads that didn&rsquo;t work for them but who have shown a real interest in your destination. This is BIG. This is what Cooperative is all about.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="ft-section">
        <div class="ft-container">
            <div class="ft-row">
                <div class="ft-col-50">
                    <div class="ft-section-image ft-screenshot mod-3d-rotate-right ft-screen-communitypage">
                        <div class="ft-browserchrome"></div>
                        <div class="ft-browserviewport"></div>
                        <div class="ft-section-image-caption">
                            <p>Concept preview. Final product may differ.</p>
                        </div>
                    </div>
                </div>
                <div class="ft-col-50">
                    <div class="ft-section-info">
                        <div class="ft-heading ft-text-plus-3">
                            Community
                        </div>
                        <p class="ft-text-plus-2">
                            Introduce travelers to local.
                        </p>
                        <p>
                            Invite new guests to explore local businesses and events that are happening during their stay. Show them what your community is all about through friendly introductions to representatives of local organizations.
                        </p>
                        <p>
                            The best part&mdash;you kick off these conversations right from Confirmation X, an Advocacy touchpoint that all cooperative partners have installed. Your cooperative partners can engage the right travelers at the right time, inspiring new guests to consider the experiences they have to offer and highlighting the best of your community.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
